import Vue from 'vue'
import Router from 'vue-router'
import iDalgoDefault from '@/layouts/iDalgo-Default'
import iDalgoUsers from '@/views/iDalgo-Users'
import iDalgoUserNew from '@/views/iDalgo-User-New'
import iDalgoUserEdit from '@/views/iDalgo-User-Edit'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/app',
      name: 'app',
      meta: { requiresAuth: true },
      redirect: { name: 'users' },
      component: iDalgoDefault,
      children: [
        {
          path: 'users',
          name: 'users',
          component: iDalgoUsers
        },
        {
          path: 'users/new',
          name: 'newUser',
          component: iDalgoUserNew
        },
        {
          path: 'users/:id',
          name: 'editUser',
          component: iDalgoUserEdit
        }
      ]
    },
    { path: '/', meta: { requiresAuth: true }, redirect: { name: 'users' } },
    { path: '*', meta: { requiresAuth: true }, redirect: { name: 'users' } }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js